import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";

import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import { useTranslation } from "react-i18next";

const PackageDistributionChart = ({ data }) => {
  const { t } = useTranslation();
  const chartData = data?.map((item) => ({
    name: item.labels?.[0] || t("common.notAvailableShort", "N/A"),
    value: item.data?.[0] || 0,
  })) || [];

  const chartConfig = {
    value: {
      label: t(
        "extendedWarranty.reports.packageDistribution.salesCount",
        "Satış Adedi",
      ),
      color: "#8B5CF6",
    },
  };

  return (
    <div className="rounded-lg border bg-white p-6">
      <h3 className="mb-4 text-lg font-medium text-[#111729]">
        {t(
          "extendedWarranty.reports.packageDistribution.title",
          "Paket Bazlı Dağılım",
        )}
      </h3>
      <p className="mb-4 text-sm text-[#677389]">
        {t(
          "extendedWarranty.reports.packageDistribution.description",
          "Garanti paketlerine göre satış dağılımı",
        )}
      </p>
      <div className="h-64">
        {data && data.length > 0 ? (
          <ChartContainer config={chartConfig} className="h-full w-full">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
                <XAxis
                  dataKey="name"
                  tick={{ fontSize: 12 }}
                  tickLine={false}
                  axisLine={false}
                />
                <YAxis
                  tick={{ fontSize: 12 }}
                  tickLine={false}
                  axisLine={false}
                />
                <ChartTooltip content={<ChartTooltipContent />} />
                <Bar dataKey="value" fill="#8B5CF6" radius={[8, 8, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </ChartContainer>
        ) : (
          <div className="flex h-full items-center justify-center text-[#677389]">
            {t(
              "extendedWarranty.reports.common.loadingData",
              "Veri yükleniyor...",
            )}
          </div>
        )}
      </div>
      <div className="mt-4 grid grid-cols-2 gap-2 text-xs">
        {data?.map((item, index) => (
          <div key={index} className="flex justify-between">
            <span className="text-[#677389]">
              {item.labels?.[0] || t("common.notAvailableShort", "N/A")}
            </span>
            <span className="font-medium">{item.percentage || "0%"}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PackageDistributionChart;
